import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

export const Section = ({ id, tone = "paper", className = "", children, testid }) => (
  <section id={id} data-testid={testid} className={`${tone === "deep" ? "bg-[color:var(--deep)] text-[color:var(--cream)]" : tone === "stone" ? "bg-[color:var(--canvas)]" : "bg-paper"} ${className}`}>
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-20 lg:py-28">{children}</div>
  </section>
);

export const Eyebrow = ({ children, light }) => (
  <p className={`t-label flex items-center gap-3 ${light ? "!text-[color:var(--stone)]" : ""}`}><span className="brand-rule !w-8" />{children}</p>
);

export const H2 = ({ children, light, className = "" }) => (
  <h2 className={`font-display font-semibold tracking-[-0.025em] text-[32px] leading-[1.12] sm:text-[42px] ${light ? "text-[color:var(--cream)]" : "text-ink"} ${className}`}>{children}</h2>
);

export const Lead = ({ children, light, className = "" }) => (
  <p className={`text-[18px] sm:text-[19px] leading-[1.6] ${light ? "text-[color:var(--stone)]" : "text-ink-soft"} ${className}`}>{children}</p>
);

export const Cta = ({ to = "/sign-up", children = "Get Started", variant = "primary", testid }) => (
  <Link to={to} className={`btn btn-lg ${variant === "primary" ? "btn-primary" : variant === "light" ? "bg-[color:var(--cream)] text-[color:var(--deep)] hover:bg-white" : "btn-outline"}`} data-testid={testid}>
    {children}{variant !== "outline" && <ArrowRight size={18} />}
  </Link>
);

export const BrowserFrame = ({ src, alt, className = "" }) => (
  <div className={`rounded-[18px] border border-line bg-surface shadow-[0_30px_80px_-30px_rgba(14,63,50,0.35)] overflow-hidden ${className}`}>
    <div className="h-9 flex items-center gap-1.5 px-4 border-b border-line bg-[color:var(--canvas)]" aria-hidden="true">
      {[0, 1, 2].map((i) => <span key={i} className="w-2.5 h-2.5 rounded-full bg-[color:var(--stone)]" />)}
    </div>
    <img src={src} alt={alt} className="w-full block" loading="lazy" />
  </div>
);

export const PhoneFrame = ({ src, alt, className = "" }) => (
  <div className={`rounded-[38px] bg-[color:var(--deep)] p-[9px] shadow-[0_30px_70px_-25px_rgba(14,63,50,0.55)] ${className}`}>
    <img src={src} alt={alt} className="w-full block rounded-[30px]" loading="lazy" />
  </div>
);

export const Ticks = ({ items, light }) => (
  <ul className="space-y-3">
    {items.map((t) => (
      <li key={t} className={`flex gap-3 text-[17px] ${light ? "text-[color:var(--cream)]" : "text-ink"}`}>
        <Check size={20} className={`shrink-0 mt-0.5 ${light ? "text-[color:var(--clay)]" : "text-[color:var(--moss)]"}`} />{t}
      </li>
    ))}
  </ul>
);
